import { useEffect } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";

const NAV = [
  ["", "Dashboard"],
  ["revenue", "Revenue"],
  ["articles", "Articles"],
  ["deals", "Deals"],
  ["destinations", "Destinations"],
  ["reviews", "Reviews"],
  ["cards", "Credit Cards"],
  ["videos", "Videos"],
  ["media", "Media Library"],
  ["prompts", "Prompt Templates"],
  ["calendar", "Content Calendar"],
  ["publish-log", "Publish Log"],
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/admin/login", { replace: true });
  }, [user, loading, navigate]);

  if (loading || !user) {
    return <div className="min-h-screen grid place-items-center text-sm font-mono text-[#4A4742]">Loading…</div>;
  }

  return (
    <div className="min-h-screen bg-white text-[#1C1A17] flex">
      <aside className="w-64 border-r border-[#D6CFC4] flex flex-col shrink-0" data-testid="admin-sidebar">
        <Link to="/" className="p-5 border-b border-[#D6CFC4]">
          <div className="font-serif text-2xl text-[#1B3B36]">JetsetLess</div>
          <div className="overline text-[#4A4742]">Editorial CMS</div>
        </Link>
        <nav className="flex-1 py-4">
          {NAV.map(([seg, label]) => (
            <NavLink
              key={seg}
              to={`/admin/${seg}`}
              end={seg === ""}
              data-testid={`admin-nav-${seg || "dashboard"}`}
              className={({ isActive }) =>
                `block px-5 py-2.5 text-sm border-l-2 ${isActive ? "border-[#B4533C] bg-[#EFECE5] text-[#1B3B36] font-medium" : "border-transparent hover:bg-[#F9F9F6]"}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-5 border-t border-[#D6CFC4] text-xs font-mono">
          <div className="text-[#4A4742]">Signed in as</div>
          <div className="mt-1 truncate">{user.email}</div>
          <button onClick={logout} className="mt-3 w-full border border-[#D6CFC4] px-3 py-2 hover:bg-[#EFECE5]" data-testid="admin-logout-btn">
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
